<template>
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
       width="100%"
  height="100%"
      viewBox="0 0 757.000000 705.000000"
      preserveAspectRatio="xMidYMid meet"
    >
    <g transform="translate(0.000000,844.000000) scale(0.160000,-0.120000)"
fill="#000000" stroke="none">
<path d="M2003 6865 c-17 -7 -60 -40 -95 -73 -35 -33 -101 -90 -148 -128 -122
-98 -567 -461 -684 -557 -55 -45 -209 -170 -341 -277 -545 -440 -602 -488
-614 -518 -18 -43 1 -97 43 -123 41 -26 124 -22 166 9 16 12 34 22 40 22 7 0
9 -343 8 -1107 l-3 -1108 -150 -3 c-161 -3 -171 -6 -201 -64 -26 -50 -18 -93
24 -138 l39 -40 771 0 c493 0 772 4 772 10 0 5 50 59 112 120 l111 110 -81 0
-82 0 0 325 0 325 370 0 370 0 0 -142 0 -143 84 0 c82 0 86 -1 118 -32 19 -18
36 -33 40 -33 7 0 9 453 2 502 -3 22 -18 51 -34 68 l-28 30 -552 0 -552 0 -29
-31 c-16 -17 -29 -41 -29 -53 -1 -11 -2 -199 -3 -416 l-3 -395 -409 0 -410 0
-2 1200 -3 1200 282 230 c424 347 962 786 1063 870 90 73 90 74 116 57 14 -9
183 -146 375 -304 350 -287 694 -568 922 -751 l122 -98 0 -846 0 -846 73 69
c39 38 93 87 120 108 l47 38 0 644 c0 354 2 644 4 644 3 0 26 -11 52 -25 53
-28 90 -31 138 -11 72 30 99 114 53 167 -12 15 -193 163 -402 330 -552 439
-814 652 -1017 822 -477 400 -478 400 -565 362z"/>
<path d="M1967 6166 c-92 -34 -162 -120 -186 -227 -5 -24 -15 -78 -21 -119
-16 -97 -48 -160 -122 -236 -66 -69 -70 -95 -20 -116 18 -7 169 -12 442 -13
449 -2 463 -1 476 50 5 21 -4 36 -53 89 -72 77 -106 155 -121 276 -19 152 -59
223 -153 275 -64 34 -179 45 -242 21z"/>
<path d="M1993 5410 c-33 -13 -28 -43 13 -79 26 -23 42 -30 57 -25 31 9 92 59
92 75 0 32 -107 51 -162 29z"/>
<path d="M1252 5023 c-12 -2 -29 -14 -37 -26 -8 -13 -53 -135 -100 -272 -135
-391 -165 -482 -165 -504 0 -28 29 -41 93 -41 66 0 80 13 117 108 l26 67 140
3 141 3 18 -61 c10 -33 26 -73 36 -90 17 -27 24 -30 70 -30 27 0 59 5 69 10
43 23 42 41 -11 191 -28 79 -56 162 -64 184 -26 80 -133 381 -148 416 -12 30
-21 37 -53 42 -42 7 -95 7 -132 0z m122 -371 c20 -57 36 -108 36 -113 0 -5
-38 -9 -85 -9 -48 0 -85 4 -85 10 0 9 8 31 60 178 15 42 26 59 31 50 4 -7 23
-60 43 -116z"/>
<path d="M1863 5023 c-48 -9 -48 -12 -48 -412 0 -344 2 -379 18 -404 l17 -27
168 0 c202 0 254 12 312 70 61 61 85 164 58 253 -12 40 -60 99 -88 109 -12 4
-11 9 6 29 48 53 64 92 64 157 0 92 -38 156 -115 194 -58 29 -302 48 -392 31z
m297 -193 c26 -26 25 -68 -2 -97 -18 -20 -31 -23 -90 -23 l-68 0 0 70 0 70 70
0 c57 0 74 -4 90 -20z m26 -323 c31 -36 32 -87 1 -122 -20 -24 -32 -27 -105
-32 l-82 -6 0 98 0 97 81 -4 c74 -3 83 -6 105 -31z"/>
<path d="M2795 5017 c-73 -19 -113 -43 -171 -102 -80 -83 -99 -144 -99 -325 0
-142 1 -146 32 -213 70 -147 169 -203 344 -195 80 3 102 8 148 33 56 31 108
85 118 123 14 58 -60 116 -118 91 -16 -6 -29 -15 -29 -19 0 -17 -88 -50 -134
-50 -71 0 -119 29 -150 92 -22 44 -26 65 -26 140 0 153 49 236 151 259 55 13
102 -3 156 -52 47 -43 71 -47 114 -22 40 24 56 66 38 101 -21 41 -89 105 -134
126 -50 24 -171 30 -240 13z"/>
<path d="M4285 4132 c-387 -218 -523 -312 -695 -482 -142 -140 -200 -215 -254
-329 -29 -62 -31 -73 -31 -181 0 -107 2 -121 33 -196 l33 -81 -108 -219 c-121
-243 -208 -438 -276 -619 -26 -66 -65 -167 -87 -225 -23 -58 -50 -127 -60
-155 -10 -27 -37 -97 -60 -155 -23 -58 -87 -220 -142 -360 -227 -574 -351
-876 -355 -863 -4 13 -49 210 -103 448 -47 206 -68 275 -198 643 l-50 142 49
73 c66 98 178 259 183 264 13 14 206 -162 206 -187 0 -6 -101 -83 -203 -155
-87 -61 -103 -84 -91 -133 7 -28 18 -41 43 -54 33 -16 36 -16 75 4 59 30 263
155 317 194 33 24 53 49 69 86 29 67 23 120 -21 193 -47 78 -241 270 -390 386
-177 138 -221 179 -253 239 -57 105 -34 192 83 313 101 105 205 178 489 342
97 56 120 87 102 141 -13 38 -40 57 -80 56 -24 -1 -231 -112 -380 -205 -187
-116 -374 -287 -425 -387 -61 -120 -67 -190 -30 -338 l26 -101 -27 -43 c-48
-75 -219 -437 -282 -598 -94 -239 -115 -292 -192 -480 -39 -96 -109 -267 -155
-380 -45 -113 -115 -283 -154 -379 -39 -96 -71 -187 -71 -203 0 -99 119 -155
190 -90 20 17 92 150 209 382 l179 355 33 -3 c19 -1 126 -4 239 -6 l205 -4 33
-108 c17 -60 60 -208 93 -329 34 -121 68 -233 76 -248 18 -35 69 -67 108 -67
33 0 95 33 95 50 0 6 16 -1 36 -16 51 -39 126 -44 174 -12 38 25 46 40 224
373 122 230 124 232 282 515 61 107 146 259 189 337 44 78 85 141 90 140 6 -2
80 -142 166 -312 169 -337 197 -410 294 -765 31 -113 65 -219 76 -237 42 -67
123 -91 196 -56 27 12 42 30 61 71 l25 55 -18 116 c-9 64 -21 132 -26 151 -4
19 -20 96 -34 170 -88 451 -77 417 -279 930 l-104 265 45 85 c25 47 59 105 76
130 54 80 220 290 229 290 11 0 100 -72 177 -142 44 -41 53 -53 44 -66 -5 -9
-88 -72 -184 -139 -96 -67 -182 -135 -192 -150 -25 -38 -17 -98 17 -132 45
-45 81 -36 256 63 188 107 259 157 326 228 73 77 81 107 51 201 -33 101 -87
175 -238 322 -121 117 -155 145 -385 313 -122 90 -190 157 -226 223 -19 37
-23 59 -23 134 0 82 3 96 34 159 24 50 60 97 125 164 139 144 252 229 525 393
140 84 165 111 157 174 -10 79 -89 117 -161 77z"/>
<path d="M4085 3490 c-67 -7 -139 -44 -202 -103 -71 -67 -96 -131 -97 -252 0
-82 3 -96 32 -157 38 -78 91 -129 176 -169 52 -25 73 -29 143 -29 68 0 92 5
138 26 101 48 181 162 205 293 19 106 -7 196 -81 276 -83 90 -187 128 -314
115z"/>
<path d="M2639 3034 c-23 -25 -144 -102 -223 -141 l-39 -20 50 -7 c48 -6 160
-66 177 -95 5 -8 97 -11 299 -11 l292 1 26 52 26 52 -25 68 -25 67 -142 0
c-78 0 -196 3 -262 6 -119 7 -120 7 -115 30 6 31 -9 30 -39 -2z"/>
<path d="M2239 2756 c-128 -49 -192 -138 -192 -266 0 -115 61 -212 169 -264
51 -25 66 -28 126 -24 52 4 79 12 116 34 57 36 116 112 132 171 13 46 19 50
38 31 23 -23 12 -74 -33 -160 -37 -71 -45 -96 -45 -140 0 -131 107 -228 219
-198 56 15 58 33 9 91 -48 58 -51 85 -17 187 16 48 20 81 17 132 -5 87 -24
115 -105 155 -51 24 -64 36 -69 60 -14 63 -76 135 -149 172 -61 31 -161 40
-216 19z"/>
</g>
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconPse'
  }
  </script>
  
  <style scoped>
  </style>
  